module.exports = __webpack_public_path__ + "static/functions-screen-2-0fb686ebe71a85aa425356a2057bba93.png";